import { AppBaseApi } from '../api';
import { AxiosResponse } from 'axios';
import { Intercom, IUpgradeActionIntercom } from '../../model/interfaces/intercom/intercom';
import { CSVSearchParamRequest } from '../api/pagedListRequest';
import { IntercomConfig } from '../../model/interfaces/intercom/intercomConfig';

export interface ResponseIntercom {
    Data: Intercom[];
    TotalCount: number;
}

export interface UpgradeConfigMode {
    Config: any;
    IsPartial: boolean;
}
export class IntercomsService extends AppBaseApi {
    public getAll(search: any): Promise<AxiosResponse<ResponseIntercom>> {
        return this.axios.post(this.basePath + '/intercoms', search)
    }

    public upgrade(mac: string, upgradeModel: IUpgradeActionIntercom): Promise<AxiosResponse<boolean>> {
        return this.axios.post(this.basePath + `/intercoms/${mac}/upgrade`,
          {Id: upgradeModel.Id, Sip: upgradeModel.Sip, WanMac: upgradeModel.WanMac})
    }

    public openGate(mac: string, note: string): Promise<AxiosResponse<boolean>> {
        return this.axios.post(this.basePath + `/intercoms/${mac}/opengate`, {Reason: note})
    }

    public closeGate(mac: string, note: string): Promise<AxiosResponse<boolean>> {
        return this.axios.post(this.basePath + `/intercoms/${mac}/closegate`, {Reason: note})
    }

    public vendGate(mac: string, note: string): Promise<AxiosResponse<boolean>> {
        return this.axios.post(this.basePath + `/intercoms/${mac}/vendgate`, {Reason: note})
    }

    public bulkUpdate(firmwareId: number, wanMacAddresses: string[]): Promise<AxiosResponse<boolean>> {
        return this.axios.post(this.basePath + `/intercoms/bulk/upgrade`, {Id: firmwareId, WanMac: wanMacAddresses})
    }

    public getDetailByWanMac(intercomWanMac: string): Promise<AxiosResponse<any>> {
        return this.axios.post(this.basePath + `/intercoms/${intercomWanMac}/config`)
    }
    public getIntercomByWanMac(intercomWanMac: string): Promise<AxiosResponse<any>> {
        return this.axios.get(this.basePath + `/intercoms/${intercomWanMac}`)
    }

    public getCSVReport(csvSearchParam: CSVSearchParamRequest): Promise<AxiosResponse<any>> {
        return this.axios.post(this.basePath + `/intercoms/csvreport`, csvSearchParam);
    }

    public bulkReboot(wanMacAddresses: string[]): Promise<AxiosResponse<boolean>> {
        return this.axios.post(this.basePath + `/intercoms/bulk/reboot`, {WanMac: wanMacAddresses})
    }

    public reboot(wanMac: string) {
        return this.axios.post(this.basePath + `/intercoms/${wanMac}/reboot`)
    }

    public getConfigById(wanMacId: string): Promise<AxiosResponse<IntercomConfig>> {
        return this.axios.get(this.basePath + `/intercoms/${wanMacId}/config`)
    }

    public downloadConfig(id: string): Promise<AxiosResponse<any>> {
        return this.axios.post(this.basePath + `/intercoms/${id}/config/download`)
    }

    public updateConfig(id: string, configModel: UpgradeConfigMode): Promise<AxiosResponse<any>> {
        return this.axios.put(this.basePath + `/intercoms/${id}/config`, configModel)
    }

}
